<template>
  <div class="card">
    <BaseLink
      class="card__name"
      :href="`/${locale}/faq/articles/${article.slug}`"
    >
      <span v-html="article.name" />
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n();

defineProps<{
  article: FaqArticle;
}>();
</script>

<style scoped>
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 8px;
  height: 100%;
  padding: 16px 24px;
  border-radius: 12px;
  background-color: var(--white);
}

.card__name {
  position: static;
}

.card__name::before {
  content: "";
  position: absolute;
  inset: 0;
}

@media (--hover) {
  .card__name:hover {
    color: var(--grey-2);
  }
}

@media (--hover) {
  .card__name:active {
    color: var(--grey-1-5);
  }
}
</style>
